import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';
import { Accordion } from 'primereact/accordion';

export const WatchlistWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(16)};
`;

export const EntityBlock = styled.div``;

export const EntityHeader = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(12)};

    h2 {
        margin: ${rem(12)} 0;
        color: #334155;
        font-size: ${rem(15)};
        font-weight: 600;
    }
`;

export const ClearChip = styled.span`
    background: #dcfce7;
    color: #15803d;
    border: 1px solid #86efac;
    padding: ${rem(3)} ${rem(10)};
    border-radius: ${rem(20)};
    font-size: ${rem(12)};
    font-weight: 600;
    white-space: nowrap;
`;

export const WarningChip = styled.span`
    background: #fef3c7;
    color: #b45309;
    border: 1px solid #fcd34d;
    padding: ${rem(3)} ${rem(10)};
    border-radius: ${rem(20)};
    font-size: ${rem(12)};
    font-weight: 600;
    white-space: nowrap;
`;

export const WatchlistAccordion = styled(Accordion)`
    .p-accordion-header a {
        height: ${rem(44)};
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        color: #334155;
    }

    .p-accordion-header a:hover {
        background: #f1f5f9;
    }

    a {
        font-size: ${rem(12)};
        display: flex;
        flex-direction: row-reverse;
    }

    p {
        font-size: ${rem(12)};
    }
`;

export const AccordionHeaderContent = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(8)};
    flex: 1;
`;

export const ServicePill = styled.span`
    background: #e2e8f0;
    color: #334155;
    padding: ${rem(2)} ${rem(8)};
    border-radius: ${rem(4)};
    font-size: ${rem(11)};
    font-weight: 700;
    font-family: monospace;
    white-space: nowrap;
`;

export const ListTitle = styled.span<{ hasMatches: boolean }>`
    flex: 1;
    font-size: ${rem(13)};
    font-weight: ${({ hasMatches }) => (hasMatches ? 600 : 400)};
    color: ${({ hasMatches }) => (hasMatches ? '#92400e' : '#374151')};
`;

export const StatusBadge = styled.span`
    font-size: ${rem(11)};
    color: #94a3b8;
`;

export const MatchCountBadge = styled.span`
    background: #fef3c7;
    color: #b45309;
    border: 1px solid #fcd34d;
    padding: ${rem(1)} ${rem(7)};
    border-radius: ${rem(20)};
    font-size: ${rem(11)};
    font-weight: 700;
`;

export const MatchDetailTable = styled.div`
    display: flex;
    flex-direction: column;
`;

// Striped label/value rows, as DDDRow / DDDRowLabel / DDDRowValue.
export const MatchDetailRow = styled.div`
    display: flex;
    gap: ${rem(16)};
    padding: ${rem(6)} ${rem(8)};
    color: #1e293b;
    font-size: ${rem(13.5)};
    line-height: 1.45;

    &:nth-of-type(even) {
        background: ${({ theme }) => theme.colors.greyscale.gray2_5};
    }
`;

export const MatchFieldLabel = styled.span`
    flex-shrink: 0;
    min-width: ${rem(120)};
    color: #64748b;
    font-weight: 500;
    text-transform: capitalize;
`;

export const AccordionIcon = styled.i`
    font-size: ${rem(10)};
    padding: ${rem(4)};
    border-radius: 50%;
    background-color: #00000020;
`;
